import React, { Component } from 'react'
import { connect } from 'react-redux';
import Service from '../../services';
import ClassetDropdown from '../../classetComponents/classetDropDown';
import { BoardsIconInActive, GradesIcon } from '../svgIcons';
import { Toast } from 'primereact/toast';
import LoadingComponent from '../loadingComponent';
import { getBoardsData, getBranchesLatest } from '../../store/actions';
import { userAssignedBoards } from '../../store/selectors/userAssignedBoards';
import ClassetMultiSelect from '../../classetComponents/classetMultiSelect';
import { cloneDeep } from 'lodash';

class BranchToSectionMultiDDPreFill extends Component {
    constructor(props) {
        super(props);
        this.state = {
            boardIds: null,
            classIds: null,
            groupId: null,
            branchIds: null,
            sectionId: null,
            boards: [],
            classes: [],
            sections: [],
            curriculumInfo: {},
        };
        this.service = new Service()
    }

    componentDidMount() {

        this.getData()
    }


    componentDidUpdate(prevProps, prevState) {
        if (this.state.branchIds == null &&
            this.props.boards && this.props.boards.length > 0 &&
            this.props.branchData && this.props.branchData.length > 0) {

            // Get filtered branches based on user's assigned branches
            const filteredBranchData = this.getFilteredBranches();

            if (filteredBranchData.length === 0) {
                return; // No accessible branches for this user
            }

            let branchdIds = filteredBranchData.map(e => e.key);

            // Get filtered boards based on branches and user role
            let filteredBoards = this.getFilteredBoards(branchdIds);

            if (filteredBoards.length > 0) {
                let boradIds = filteredBoards?.map(e => e.boardId);

                let filterClasses = filteredBoards?.filter(board => board.boardId === boradIds[0])?.map(e => e.classes).flat();

                let filterClassIds = filterClasses?.map(e => e.classId);

                let filteredSections = filterClasses.filter(e => e.classId === filterClassIds[0])?.map(e => e.sections).flat()
                    .filter(sec => {
                        // Only include sections that belong to the FIRST selected branch
                        const belongsToFirstBranch = sec?.branchId === branchdIds[0];

                        // Additional check: ensure this section's board is the one we're looking at
                        const belongsToCurrentBoard = filteredBoards.some(board =>
                            board.boardId === boradIds[0] &&
                            board.assignedBranches?.includes(sec?.branchId) &&
                            board.classes?.some(cls =>
                                cls.classId === filterClassIds[0] &&
                                cls.sections?.some(s => s.sectionId === sec.sectionId)
                            )
                        );

                        return belongsToFirstBranch && belongsToCurrentBoard;
                    });

                // Apply teacher-specific section filtering
                filteredSections = this.getFilteredSections(filteredSections, branchdIds, boradIds, filterClassIds);

                let sectionIds = filteredSections?.map(e => e.sectionId);

                let selectedsectionName = '';
                let selectedsectionId = '';

                if (filteredSections.length > 0) {
                    selectedsectionName = filteredSections[0].sectionName;
                    selectedsectionId = sectionIds[0];
                }

                let selectedbranchName = '';
                if (filterClasses.length > 0) {
                    selectedbranchName = filterClasses?.filter(item => item.classId === filterClassIds[0])?.map(e => e.branches).flat();
                }

                if (selectedsectionId !== this.state.sectionId) {
                    this.setState({
                        branches: filterClasses[0]?.branches,
                        branchIds: [branchdIds[0]],
                        boards: filteredBoards,
                        boardIds: [boradIds[0]],
                        classes: filterClasses,
                        classIds: [filterClassIds[0]],
                        selectedClassName: filterClasses[0]?.className,
                        selectedbranchName: selectedbranchName && selectedbranchName[0]?.branchName,
                        sections: filteredSections,
                        sectionId: selectedsectionId,
                        selectedsectionName: selectedsectionName,
                    }, () => {
                        this.state?.sectionId && this.setDropdownsData();
                    });
                }
            }
        }
    }

    getData = () => {
        /*        this.props.getBranchesLatest();
               this.props.getBoardsData(true) */
    }

    // Helper method to check if user is a teacher
    isTeacher = () => {
        // Check user type from localStorage
        const userType = localStorage.getItem('type');

        // Only if type is 'teacher', check for assignedSubjects
        if (userType === 'teacher') {
            return this.props.userInfo?.assignedSubjects && this.props.userInfo.assignedSubjects.length > 0;
        }

        // For all other types (admin, staff, etc.), return false (they get all sections)
        return false;
    }

    // Helper method to remove duplicates based on unique ID
    removeDuplicates = (array, idKey) => {
        if (!array || array.length === 0) return [];

        const seen = new Set();
        return array.filter(item => {
            const id = item[idKey];
            if (seen.has(id)) {
                return false;
            }
            seen.add(id);
            return true;
        });
    }

    // Filter branches based on user's assigned branches
    getFilteredBranches = () => {
        const { userInfo, branchData } = this.props;

        // If user is admin, return all branches
        if (userInfo?.isAdmin === true) {
            return this.removeDuplicates(branchData || [], 'key');
        }

        // For non-admin users, filter by assigned branches
        if (!userInfo.branchs || userInfo.branchs.length === 0) {
            return this.removeDuplicates(branchData || [], 'key');
        }

        const filtered = branchData.filter(branch =>
            userInfo.branchs.includes(branch.key)
        );

        return this.removeDuplicates(filtered, 'key');
    }

    // Filter boards based on user's assigned branches and boards
    getFilteredBoards = (selectedBranchIds) => {
        const { userInfo, boards } = this.props;

        let filteredBoards = cloneDeep(boards || []);

        // If user is admin, return all boards (filtered only by selected branches if any)
        if (userInfo?.isAdmin === true) {
            // Filter by selected branches only
            if (selectedBranchIds && selectedBranchIds.length > 0) {
                filteredBoards = filteredBoards.filter(board =>
                    board.assignedBranches.some(branchId => selectedBranchIds.includes(branchId))
                );
            }
        } else {
            // For non-admin users, filter by selected branches
            if (selectedBranchIds && selectedBranchIds.length > 0) {
                filteredBoards = filteredBoards.filter(board =>
                    board.assignedBranches.some(branchId => selectedBranchIds.includes(branchId))
                );
            }

            // For teachers, additionally filter by assigned boards
            if (this.isTeacher() && userInfo?.boardId && userInfo?.boardId.length > 0) {
                filteredBoards = filteredBoards.filter(board =>
                    userInfo?.boardId.includes(board.boardId)
                );
            }
            // For non-admin, non-teacher users, filter by assigned boards if available
            else if (!this.isTeacher() && userInfo?.boardId && userInfo?.boardId.length > 0) {
                filteredBoards = filteredBoards.filter(board =>
                    userInfo?.boardId.includes(board.boardId)
                );
            }
        }

        // Remove duplicate boards by boardId
        filteredBoards = this.removeDuplicates(filteredBoards, 'boardId');

        // Add display names
        filteredBoards.forEach((board) => {
            board?.classes?.forEach((classs) => {
                classs.className = board?.boardName + ' -- ' + classs.className;
                classs.sections.forEach((sec) => sec.sectionName = classs.className + ' -- ' + sec.sectionName);
            });
        });

        return filteredBoards;
    }

    // Filter sections based on user role
    getFilteredSections = (sections, selectedBranchIds, selectedBoardIds, selectedClassIds) => {
        const { userInfo } = this.props;

        // If user is admin, return all sections
        if (userInfo?.isAdmin === true) {
            return this.removeDuplicates(sections, 'sectionId');
        }

        // If not a teacher, return all sections (no filtering needed)
        if (!this.isTeacher()) {
            return this.removeDuplicates(sections, 'sectionId');
        }

        // If teacher but no assignedSections, return empty array (no sections accessible)
        if (!userInfo?.sections || userInfo.sections.length === 0) {
            return [];
        }

        // For teachers with assignedSections, filter by assigned sections
        const filtered = sections.filter(section =>
            userInfo.sections.includes(section.sectionId)
        );

        return this.removeDuplicates(filtered, 'sectionId');
    }

    onChangeBranch = (branchIds) => {

        this.setState({
            boards: [], classes: [], sections: [],
        });

        // Use filtered boards based on selected branches and user role
        let filteredBoards = this.getFilteredBoards(branchIds);

        this.setState({
            branchIds: branchIds,
            boards: filteredBoards,
            classes: [],
            boardIds: '',
            classIds: '',
            branches: [],
            sections: [],
            sectionId: '',
            selectedsectionName: '',
        },);
    };

    onChangeBoard = (boardIds) => {
        this.setState({
            classes: [], sections: [],
        });

        let filteredClasses = [];

        this.state.boards.forEach(board => {
            if (boardIds.includes(board.boardId)) {
                filteredClasses.push(...board.classes);
            }
        });

        // Remove duplicate classes by classId
        filteredClasses = this.removeDuplicates(filteredClasses, 'classId');

        this.setState({
            classes: filteredClasses,
            boardIds,
            classIds: '',
            branches: [],
            sections: [],
            sectionId: '',
            selectedsectionName: '',

        },);
    };

    onChangeClass = (classIds) => {
        this.setState({
            sections: [],
        });

        let lsecs = []

        // For each selected class ID
        classIds?.forEach(classId => {
            // Find the class in the current classes
            const selectedClass = this.state.classes?.find(cls => cls.classId === classId);

            if (selectedClass && selectedClass.sections) {
                // Filter sections for this specific class
                const validSections = selectedClass.sections.filter(sec => {
                    // Check if section belongs to selected branch
                    const belongsToSelectedBranch = this.state.branchIds?.includes(sec?.branchId);

                    // Check if section is from the selected board
                    const isFromSelectedBoard = this.state.boardIds?.some(boardId => {
                        const board = this.state.boards.find(b => b.boardId === boardId);
                        if (!board) return false;

                        // Verify this board:
                        // 1. Is assigned to the section's branch
                        // 2. Contains this specific class
                        // 3. Contains this specific section
                        const isBoardAssignedToBranch = board.assignedBranches?.includes(sec?.branchId);
                        const boardHasThisClass = board.classes?.some(cls => cls.classId === classId);
                        const boardHasThisSection = board.classes?.some(cls =>
                            cls.classId === classId &&
                            cls.sections?.some(s => s.sectionId === sec.sectionId)
                        );

                        return isBoardAssignedToBranch && boardHasThisClass && boardHasThisSection;
                    });

                    return belongsToSelectedBranch && isFromSelectedBoard;
                });

                lsecs.push(...validSections);
            }
        });

        // Apply teacher-specific filtering to sections
        lsecs = this.getFilteredSections(lsecs, this.state.branchIds, this.state.boardIds, classIds);

        this.setState({
            classIds: classIds,
            sections: lsecs,
            sectionId: '',
            selectedsectionName: ''
        },);
    };

    onChangeSection = (sectionId) => {
        let selectedsection = this.state.sections?.find((sectiond) => sectiond.sectionId == sectionId);
        let selectedsectionName = selectedsection?.sectionName;
        this.setState({
            sectionId: sectionId,
            selectedsectionName: selectedsectionName,
        }, () => this.setDropdownsData());
    };

    setDropdownsData = () => {
        let {
            boardIds,
            classIds,
            branchIds,
            sectionId,
        } = this.state
        this.props.setValues({
            boardIds, classIds, branchIds, sectionId,
        })
    }



    render() {
        // Get filtered branches for the dropdown options
        const filteredBranchData = this.getFilteredBranches();

        return (
            <div>
                <div >
                    <div className='grid m-2'>
                        <div className=" col-3">
                            <ClassetMultiSelect required={true} label={'Branch'}
                                // icon={<BoardsIconInActive height={16.5} width={19.5} />}
                                placeholder={'Select Branch'}
                                options={filteredBranchData}
                                value={this.state.branchIds}
                                onChange={(e) => this.onChangeBranch(e.value)}
                                optionLabel="name"
                                optionValue="key" disabled={this.props.selectedValue === 2 ? true : false} />
                        </div>
                        <div className=" col-3">
                            <ClassetMultiSelect label={'Board'}
                                // icon={<BoardsIconInActive height={16.5} width={19.5} />}
                                placeholder={'Select Board'}
                                options={this.state.boards} value={this.state.boardIds}
                                onChange={(e) => this.onChangeBoard(e.value)}
                                optionLabel="boardName"
                                optionValue="boardId" disabled={this.props.selectedValue === 2 ? true : false} />
                        </div>
                        <div className=" col-3">
                            <ClassetMultiSelect label={'Grade'}
                                // icon={<GradesIcon />} 
                                placeholder={'Select (Board - Grade)'}
                                options={this.state?.classes}
                                value={this.state.classIds}
                                onChange={(e) => this.onChangeClass(e.value)} optionLabel="className"
                                optionValue="classId"
                                disabled={this.props.selectedValue === 2 ? true : false} />
                        </div>
                        <div className=" col-3">
                            <ClassetDropdown label={'Section'}
                                //  icon={<GradesIcon />}
                                placeholder={'Select (Board - Grade - Section)'}
                                options={this.state?.sections}
                                value={this.state.sectionId}
                                onChange={(e) => this.onChangeSection(e.value)}
                                optionLabel="sectionName"
                                optionValue="sectionId"
                                disabled={this.props.selectedValue === 2 ? true : false} />
                        </div>
                    </div>
                </div>
                <Toast ref={(el) => this.toast = el} position="bottom-right" />
                {this.state.isLoading && <>
                    <LoadingComponent />
                </>}
            </div>
        )
    }
}

const mapStatesToProps = (state) => ({
    boards: userAssignedBoards(state, 'activeBoards'),
    branchData: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data.data.filter((each => {
        if (each.level == 1) {
            return { ...each }
        }
    })) || [],
    permissionIds: state.currentUserPerms && state.currentUserPerms.permissionIds && state.currentUserPerms.permissionIds,
    userInfo: state.currentUserPerms && state.currentUserPerms.userInfo ? state.currentUserPerms.userInfo : {},
});
export default connect(mapStatesToProps, { getBoardsData, getBranchesLatest })(BranchToSectionMultiDDPreFill);